<template>
  <v-container fluid>
    <v-row align-content="end">
      <v-col cols="6" sm="4">
        <v-select
          @change="value => this.handleChange('eventType', value)"
          label="Стата"
          :items="eventTypeOptions"
          :value="eventType"
        />
      </v-col>

      <v-col cols="2" sm="2">
        <v-btn-toggle
          borderless
          mandatory
          @change="value => this.handleChange('dateRange', value)"
          :value="dateRange"
        >
          <v-btn
            :disabled="eventType === HOURLY_CHAT_STATISTICS"
            v-bind:key="option.value"
            v-for="option in dateRangeOptions"
            :value="option.value"
          >
            {{ option.text }}
          </v-btn>
        </v-btn-toggle>
      </v-col>

      <v-col cols="2" sm="2">
        <date-picker
          @input="value => this.handleChange('date', value)"
          :label="'Дата'"
          :max-date="maxDate"
          :type="dateRange === DATE_RANGE.MONTH ? DATE_RANGE.MONTH : undefined"
          :value="date"
        />
      </v-col>

      <v-col cols="2" sm="2">
        <v-btn @click="() => $emit('submit')" :loading="loading">submit</v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import DatePicker from '../../../components/common/datePicker/DatePicker.vue';
import { EVENT, DATE_RANGE } from '@/lib/const';
import { getISODate } from '@/lib/utils';

const { HOURLY_CHAT_STATISTICS, DEPARTMENT_ADD, DEPARTMENT_REMOVE } = EVENT;
const { DAY, MONTH } = DATE_RANGE;

export default {
  name: 'AppInsightsFilters',

  components: {
    DatePicker,
  },

  props: {
    date: String,
    dateRange: String,
    eventType: String,
    loading: Boolean,
  },

  data() {
    return {
      HOURLY_CHAT_STATISTICS,
      DATE_RANGE,
      maxDate: getISODate(new Date()),
      eventTypeOptions: [
        {
          text: 'Статистика по чатам (почасовая)',
          value: HOURLY_CHAT_STATISTICS,
        },
        {
          text: 'Чат добавлен в отдел',
          value: DEPARTMENT_ADD,
        },
        {
          text: 'Чат удален из отдела',
          value: DEPARTMENT_REMOVE,
        },
      ],
      dateRangeOptions: [
        {
          text: 'День',
          value: DAY,
        },
        {
          text: 'Месяц',
          value: MONTH,
        },
      ],
    };
  },

  methods: {
    handleChange(key, value) {
      if (value === HOURLY_CHAT_STATISTICS) {
        this.$emit('change', 'dateRange', DAY);
      }

      this.$emit('change', key, value);
    },
  },
};
</script>
